import { z } from "zod";
import { TCRUDByTDate } from "../common/CRUDBy";
import { TDate } from "../common/date";

// Create schema for firestore
export type IFormDistributionCreate = z.infer<typeof TFormDistributionCreate>;
export const TFormDistributionCreate = z.object({
  formID: z.string(),
  propertyID: z.string(),
  unitID: z.string(),
});

// Main schema that extends the created schema
export type IFormDistribution = z.infer<typeof TFormDistribution>;
export const TFormDistribution = TFormDistributionCreate.extend({
  id: z.string(),
  createdBy: TCRUDByTDate,
  openedAt: z.array(TDate).default([]),
});

// Controller schema
export type IFormDistributionRecipient = z.infer<
  typeof TFormDistributionRecipient
>;
export const TFormDistributionRecipient = z.object({
  propertyID: z.string(),
  unitID: z.string(),
  email: z.string().email(),
});

export type IFormDistributionCreateRequest = z.infer<
  typeof TFormDistributionCreateRequest
>;
export const TFormDistributionCreateRequest = z.object({
  formID: z.string(),
  recipients: z.array(TFormDistributionRecipient),
  title: z.string().min(1),
  body: z.string().min(1),
  ctaLabel: z.string().optional(),
});
